/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { CvRestControllerService } from './services/cv-rest-controller.service';
import { UserRoleRestControllerService } from './services/user-role-rest-controller.service';
import { SkillRestControllerService } from './services/skill-rest-controller.service';
import { ProjectRestControllerService } from './services/project-rest-controller.service';
import { MasterDataRestControllerService } from './services/master-data-rest-controller.service';
import { UserAccountRestControllerService } from './services/user-account-rest-controller.service';
import { TechnologyRestControllerService } from './services/technology-rest-controller.service';
import { ProjectRoleRestControllerService } from './services/project-role-rest-controller.service';
import { LanguageRestControllerService } from './services/language-rest-controller.service';
import { GreybeeRoleRestControllerService } from './services/greybee-role-rest-controller.service';
import { BranchRestControllerService } from './services/branch-rest-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    CvRestControllerService,
    UserRoleRestControllerService,
    SkillRestControllerService,
    ProjectRestControllerService,
    MasterDataRestControllerService,
    UserAccountRestControllerService,
    TechnologyRestControllerService,
    ProjectRoleRestControllerService,
    LanguageRestControllerService,
    GreybeeRoleRestControllerService,
    BranchRestControllerService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
